import { IMenuItemService } from "../../service/menu/MenuItemService";
import { IMenuItem } from "../../model/menu/MenuItem";

export default class UpdateMenuItemInteractor {
  private menuItemService: IMenuItemService;

  constructor(menuItemService) {
    this.menuItemService = menuItemService;
  }

  async execute(menuItem: IMenuItem) {
    return this.menuItemService.updateMenuItem(menuItem);
  }
}
